import { useQuery } from '@tanstack/react-query';

import useRequiredParams from '@polyai/common/hooks/useRequiredParams';

import api from 'api';
import type { HTTPError } from 'api/error';
import { useToast } from 'hooks/useToast';

const LATENCY_VIZ_QUERY_KEY = 'latencyViz';

const useLatencyViz = () => {
  const { accountId, projectId, conversationId } = useRequiredParams<{
    accountId: string;
    projectId: string;
    conversationId: string;
  }>();

  const toast = useToast();

  const queryKey = [
    accountId,
    projectId,
    conversationId,
    LATENCY_VIZ_QUERY_KEY,
  ];

  const {
    data: htmlContent,
    isLoading,
    error,
  } = useQuery({
    queryFn: () =>
      api.getConversationLatencyViz(conversationId, accountId, projectId),
    queryKey,
    retry: false,
    onError: (error: HTTPError) => {
      toast.error({
        title: `Failed to fetch latency visualization`,
        description: error.message,
      });
    },
  });

  return {
    htmlContent,
    isLoading,
    error,
  };
};

export default useLatencyViz;
